import React, { useContext } from 'react';
import { UserContext } from '../UserAndProfile/UserContext'; // Removed UserData as it's implicitly used via UserContext
import { Container, Box, Typography, CircularProgress, Alert, useTheme, useMediaQuery, Button } from '@mui/material'; // Removed Tabs, Tab, Paper, AppBar
import { Link, Navigate, useNavigate } from 'react-router-dom'; // For redirecting if no plan exists
import AssessmentIcon from '@mui/icons-material/Assessment'; // Keep if used within OverallTab or for the title maybe? (Let's remove for now, can add back if needed)
import OverallTab from './OverallTab'; // Keep this import
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const StudyPlanPage: React.FC = () => {
  const { user, loading: userLoading, initialLoading } = useContext(UserContext);
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Handle Loading States
  if (initialLoading || userLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Handle No User or No Study Plan
  if (!user) {
    return <Navigate to="/sat" replace />;
  }

  if (!user.studyPlan) {
    return (
      <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
        <Alert severity="info">
          You haven't created a study plan yet.
          <Link to="/sat" style={{ marginLeft: '8px' }}>Go to Dashboard to create one.</Link>
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 13, mb: 4 }}>
      <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: { md: "center" }, 
              justifyContent: { md: "space-between" }, gap: 2, position: "relative",
              borderBottom: 1, borderColor: "divider"}}>
        <Button variant="contained" color="primary" startIcon={<ArrowBackIcon />} onClick={() => navigate('/sat')}
          sx={{ mx: 2, mb: {xs: 0, md: 3}, mt: {xs: 0, md: 1}, position: {md: "absolute", xs: "relative"}, left: {md: 0, xs: "auto"} }}>Back to Dashboard
        </Button>
        <Typography variant="h4" gutterBottom component="h1" sx={{ mb: 3, textAlign: "center", width: {md: "100%", xs: "auto"} }}>
          My Study Plan Overview
        </Typography>

      </Box>
      
      

      <OverallTab />

    </Container>
  );
};

export default StudyPlanPage;